export default __webpack_public_path__ + "static/media/spot.ba948d46.svg";